import {format} from 'url';
import {SET_LISTINGS, LOADING_LISTINGS, FAILED_LISTINGS} from './action-types';
import {getPrefix, buildSerpUrl} from '../utils/urls';

import {isUnrefined} from '../utils/listings';

export const setListings = (listings, lastCardUrl) => {
    return {
        type: SET_LISTINGS,
        ...listings,
        lastCardUrl
    };
};

export const loadingListings = (segmentKey, timeoutMs) => {
    return {type: LOADING_LISTINGS, segmentKey, timeoutMs};
};

export const failedListings = () => {
    return {type: FAILED_LISTINGS};
};

const getLastCardSEOUrl = ({serpUrlFilters, segmentKey, keywords, serpUrlDomain: host, name}) => {
    const filterUrl = serpUrlFilters[segmentKey] || {};
    const params = {
        ...filterUrl,
        q: keywords
    };

    return buildSerpUrl({
        host,
        params,
        name,
        searchRoot: true,
        useHAStyle: true
    });
};

export const fetchListings = (segmentKey) => {
    return (dispatch, getState) => {
        const {
            destination: {
                details: {lbsId},
                segmentFilters: {timeoutMs},
                serpUrlFilters
            },
            search: {serpUrlDomain, keywords},
            config: {site: {name}}
        } = getState();
        dispatch(loadingListings(segmentKey, timeoutMs));

        const lastCardUrl = getLastCardSEOUrl({serpUrlFilters, segmentKey, keywords, serpUrlDomain, name});

        const query = {id: lbsId};

        if (!isUnrefined(segmentKey)) {
            query.refinementKey = segmentKey;
        }

        const requestUrl = format({
            pathname: `/${getPrefix()}/api/listings`,
            query
        });

        const getListings = fetch(requestUrl)
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Failed loading listings');
                }
                return res.json();
            })
            .then((listings) => {
                if (listings && listings.inventoryCount > 0) {
                    dispatch(setListings(listings, lastCardUrl));
                } else {
                    throw new Error('No listings');
                }
            });

        const timeout = new Promise((resolve, reject) => {
            const wait = setTimeout(() => {
                clearTimeout(wait);
                reject(`Timed out in ${timeoutMs} ms.`);
            }, timeoutMs);
        });

        return Promise.race([getListings, timeout])
            .catch(() => dispatch(failedListings()));
    };
};
